import { render, staticRenderFns } from "./TarjetasBeneficio.vue?vue&type=template&id=7f9fa759&scoped=true&"
import script from "./TarjetasBeneficio.vue?vue&type=script&lang=js&"
export * from "./TarjetasBeneficio.vue?vue&type=script&lang=js&"
import style0 from "./TarjetasBeneficio.vue?vue&type=style&index=0&id=7f9fa759&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9fa759",
  null
  
)

export default component.exports